module.exports = __webpack_public_path__ + "static/media/logo_stockwatch.29122139.webp";